import { FC } from 'react';

import * as S from './Title.styles';

interface TitleProps {
  main: string;
  subtitle: string;
  onDoubleClick: (() => void) | undefined;
}

export const Title: FC<TitleProps> = ({ main, subtitle, onDoubleClick }) => {
  return (
    <S.Container onDoubleClick={onDoubleClick}>
      <S.Main>{main}</S.Main>
      <S.Subtitle>{subtitle}</S.Subtitle>
    </S.Container>
  );
};
